import VueScrollTo from 'vue-scrollto';
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { Prop, Provide } from 'vue-property-decorator';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import isString from 'lodash/isString';

import { FormWrapperLayoutModel } from '@/forms/FormElements/Common/FormWrapper/FormWrapper.type';

import { validationMixin } from 'vuelidate';

import Message from '@/forms/Validations/Message';

import {
  getFieldByPath,
  setFieldValueByPath,
  getPathByParts,
  emptifyFieldsByValueMutation,
  addWaiter,
  removeNulls,
  walkObjectDeep,
} from '@/utils/commonUtils';
import { replaceAllByArrays } from '@/utils/stringUtils';

// import { sendInputEvent, sendSubmitEvent } from '@/utils/gtmUtils';
// import { scrollToElement } from '@/utils/domUtils';

import FormWrapper from '@/forms/FormElements/Common/FormWrapper/FormWrapper.vue';

@Component({
  components: { FormWrapper },
  data: function() {
    const getModelMessages = (this as any).getModelMessages as any;
    if (getModelMessages) {
      const { model, messages } = getModelMessages();
      return { model, messages };
    }
    return {};
  },
})
export default class FormValidationMixin extends mixins(validationMixin) {
  @Prop(Object)
  readonly initialModel!: object;

  @Prop(Boolean)
  readonly inPopup!: boolean;

  FormWrapperLayoutModel = FormWrapperLayoutModel;

  model!: any;
  messages!: Message[];

  created() {
    if (this.initialModel) {
      const cleanedInitialModel = removeNulls(this.initialModel);
      this.model = merge(this.model, cleanedInitialModel);
    }
  }
  @Provide()
  getModel(subModel: string) {
    return getFieldByPath(this.model, subModel);
  }

  @Provide()
  getValidation(name: string) {
    return getFieldByPath(
      this.$v,
      getPathByParts('model', replaceAllByArrays(name, ['[', ']'], ['.$each.', ''])),
    );
  }

  @Provide()
  getErrorMessages(name: string) {
    if (name) {
      return this.messages.filter((m: Message) => m.key.startsWith(name));
    }

    return this.messages;
  }

  @Provide()
  inputToModel(name: string, value: any, isBlur?: boolean) {
    setFieldValueByPath(this.model, `${name}`, value);

    // if (isBlur) {
    //   sendInputEvent(name, value, this.gtmConfig);
    // }
  }

  async hasErrors() {
    return new Promise((resolve) => {
      if (this.$v) {
        this.$v.$touch();

        addWaiter(
          () => !this.$v.$pending,
          () => resolve(this.$v.$error),
        );
      }

      return false;
    });
  }

  async postValidation() {
    return Promise.resolve(true);
  }

  async submit(event?: Event) {
    if (event) {
      event.preventDefault();
    }

    const isError = await this.hasErrors();
    if (!isError) {
      const postResult = await this.postValidation();
      if (postResult) {
        // sendSubmitEvent(this.gtmConfig);

        const sendModel = cloneDeep(this.model);

        walkObjectDeep(sendModel, (rootObject: object, key: string, value: any) => {
          if (isString(value)) rootObject[key] = value.trim();
        });

        this.$emit('submit', sendModel);
      }
    } else {
      this.moveToError();
      //console.log('form is invalid', JSON.parse(JSON.stringify(this.$v)));
    }
  }

  moveToError() {
    Vue.nextTick(() => {
      let container = 'body';
      if (this.inPopup) {
        if (document.querySelector('[data-popup-container]')) {
          container = '[data-popup-container]';
        }
      }

      VueScrollTo.scrollTo('.field-wrapper.error', {
        container,
        duration: 0,
        offset: -40,
      });
    });
  }

  clearModel() {
    this.$v.$reset();
    // TODO make deep emptify
    emptifyFieldsByValueMutation(this.model);
  }

  getArraySubModel(name: string, index: number) {
    if (!name) throw new Error('getArraySubModel got empty name');

    return `${name}[${index}]`;
  }
}
